import React from 'react';
import { IFileUploader } from "../type/upload-document-modal.types";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload, UploadProps } from "antd/lib";
import { RcFile } from "antd/lib/upload";
import { bytesToMegaBytes } from "../utils/document-utils";


const FileUploader: React.FC<IFileUploader> = (props) => {


    const draggerProps: UploadProps = {
        multiple: props.allowMultiple,
        showUploadList: false,
        beforeUpload: (file: RcFile) => {
            const allowedTypes = props.documentValidationsByType?.allowedTypes;
            const maxSizeMB = props.documentValidationsByType?.maxSizeMB;

            const fileType = file.type?.split('/').pop()?.toLowerCase();
            const fileSizeMB = bytesToMegaBytes(file.size ?? 0);

            if (fileType && allowedTypes && !allowedTypes.includes(fileType)) {
                message.error(`Invalid file type. Allowed formats: ${allowedTypes.join(', ')}.`);
                return Upload.LIST_IGNORE;
            }

            if (maxSizeMB && fileSizeMB > maxSizeMB) {
                message.error(`"${file.name}" exceeds the maximum size of ${maxSizeMB} MB.`);
                return Upload.LIST_IGNORE;
            }

            props.updateFiles(file);

            return false;
        }
    };


    return (
        <div>
        <span className={'upload-document-modal__file-upload-label'}>
                Attach File
            </span>
            <div className="upload-document-modal__file-upload">

                <Dragger {...draggerProps}
                         className={`upload-document-modal__file-upload__input ${props.isEnabled ? '' : 'disable'}`}>

                    <InboxOutlined className="upload-document-modal__file-upload__drag-icon"/>
                    <p className="upload-document-modal__file-upload__text">
                        <strong>Drop here</strong> , or browse
                    </p>
                    <p className={'upload-document-modal__file-upload__description'}>
                        {props.allowMultiple ? 'multiple file allowed' : 'single file allowed'}
                    </p>
                    <div className={'upload-document-modal__file-upload__tag-wrapper'}>
                        {props.documentValidationsByType?.maxSizeMB &&
                        <span
                            className={'tags'}>
                            {props.documentValidationsByType?.maxSizeMB} MB
                        </span>}

                        {props.documentValidationsByType?.allowedTypes &&
                        props.documentValidationsByType.allowedTypes.map((a) => (
                            <span className={'tags'} key={a}>{a}</span>
                        ))}
                    </div>
                </Dragger>

            </div>
        </div>
    )
}

export default FileUploader;
